import React from 'react';

const RecognitionImpact = () => {

  return (
    <section className="bg-white">
      <div className="pt-12">
        <div className="max-w-5xl mx-auto px-6 lg:px-8 pb-6">
          <section className="pt-4">
            {/* Content Section */}
            <div className="bg-gray-100 p-8 rounded-xl shadow-sm border border-apple-gray-200 mb-8">
              <div className="flex items-center mb-6">
                <div className="bg-apple-gray-700 rounded-full p-3 mr-4">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"></path>
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-apple-gray-800">Celebrating Impact</h3>
              </div>

              <p className="text-apple-gray-700 leading-relaxed text-lg">
                On Día del Ingeniero 2024, Charly Cardeno was honored by the Universidad de Cartagena for his valuable contributions to elevating the visibility, structure, and reputation of the Software Engineering program. His efforts in fostering partnerships with tech companies and mentoring initiatives have left a lasting mark on both students and faculty.
              </p>
            </div>

            {/* Key Contributions */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
              {/* Program Development */}
              <div className="bg-white p-6 rounded-xl shadow-sm border border-apple-gray-200">
                <div className="bg-apple-gray-700 rounded-full p-3 w-fit mb-4">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v4a2 2 0 01-2 2h-2a2 2 0 00-2-2z"></path>
                  </svg>
                </div>
                <h4 className="text-lg font-semibold text-apple-gray-800 mb-2">Program Visibility</h4>
                <p className="text-apple-gray-700 text-sm">Enhanced the reputation and recognition of the Software Engineering program</p>
              </div>

              {/* Industry Partnerships */}
              <div className="bg-white p-6 rounded-xl shadow-sm border border-apple-gray-200">
                <div className="bg-apple-gray-700 rounded-full p-3 w-fit mb-4">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2-2v2m8 0V6a2 2 0 012 2v6a2 2 0 01-2 2H6a2 2 0 01-2-2V8a2 2 0 012-2V6"></path>
                  </svg>
                </div>
                <h4 className="text-lg font-semibold text-apple-gray-800 mb-2">Industry Collaboration</h4>
                <p className="text-apple-gray-700 text-sm">Established partnerships with leading tech companies and organizations</p>
              </div>

              {/* Mentoring */}
              <div className="bg-white p-6 rounded-xl shadow-sm border border-apple-gray-200">
                <div className="bg-apple-gray-700 rounded-full p-3 w-fit mb-4">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z"></path>
                  </svg>
                </div>
                <h4 className="text-lg font-semibold text-apple-gray-800 mb-2">Student Mentorship</h4>
                <p className="text-apple-gray-700 text-sm">Mentored students and faculty through career development initiatives</p>
              </div>
            </div>

            {/* Recognition Button */}
            <div className="text-center">
              <a
                href="https://drive.google.com/file/d/1ffF_tJcSrxRtWdderBd-22Rh270ZPuot/view"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-8 py-4 bg-apple-gray-700 text-white font-semibold rounded-lg hover:bg-apple-gray-800 transition duration-300 shadow-lg hover:shadow-xl"
              >
                <svg className="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                </svg>
                View Official Recognition (PDF)
                <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path>
                </svg>
              </a>
            </div>
          </section>
        </div>
      </div>
    </section>
  );
};

export default RecognitionImpact;